// extracted by mini-css-extract-plugin
export default {"snapContainer":"GD_STD_snapContainer__FwAKC","snapSection":"GD_STD_snapSection__0mjWR"};